import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import * as ValidationMessages from '../constants/ValidationMessages';
import * as DataPattern from '../constants/DataPattern';
import * as PswdManager from '../../utils/auth/AuthCognito';
import BucketContext from "../context/BucketContext";

const PasswordResetComponent = (props) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const bucketContext = useContext(BucketContext);

    var errMsg = bucketContext.bucket.pswdResetErrMsg;

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Grid container justify="center" alignItems="center" direction="column" minHeight={{minHeight: "50vh"}} pt={{xs: 5, sm: 5}} spacind={5}>
                <Grid item style={{ border: "0.2px solid gray", width: "500px"}} sx={{px: 2, py: 2}}>

                    <form id='loginForm' onSubmit={handleSubmit(props.handleSubmitResetPassword)}>
                    <Grid container justify="center" alignItems="center" direction="column">

                        <Box textAlign="center"
                            sx={{width: "100%", height: 70,}}
                        > 
                            <Typography variant="h5">Nu puteti face Login?</Typography>
                            <Divider sx={{ borderBottomWidth: 1, borderColor: "black", mt: 1 }} />
                            <Typography variant="subtitle2">Introduceti adresa de e-mail si va vom trimite un cod pentru a reseta parola</Typography>
                        </Box>

                        {!errMsg ?
                            <React.Fragment></React.Fragment>
                                :
                            <Typography
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 1 }}
                            >
                                {errMsg}
                            </Typography>
                        }

                        <Box sx={{padding: 3}}></Box>
                        <TextField variant="standard" size="small" label="Adresa Email" fullWidth margin="dense"
                            {...register("username",
                                {
                                    required: ValidationMessages.REQUITED_MESSAGE,
                                    pattern: {
                                        value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                        message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                                    }
                                }
                            )}
                            error={!!errors?.username}
                            helperText={errors?.username ? errors.username.message : null}
                        />

                        <Button variant="outlined" type='submit' sx={{width: 200, margin: 3}}>Trimite Codul</Button>

                    </Grid>
                    </form>
                </Grid>
            </Grid>

        </Box>
        </Container>

    );
}


const PasswordResetConfirmComponent = (props) => {
    const { register, handleSubmit, getValues, formState: { errors } } = useForm();
    const bucketContext = useContext(BucketContext);

    const [showPassword, setShowPassword] = React.useState(false);
    const [showPasswordConf, setShowPasswordConf] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickShowPasswordConf = () => setShowPasswordConf(!showPasswordConf);

    var errMsg = bucketContext.bucket.pswdResetErrMsg;

    const validatePasswordMatch = (passwordConf) => {
        const password = getValues('newPassword');
        if(password && password !== passwordConf) {
            return ValidationMessages.PWD_AND_PWD_CONF_MISMATCH;
        }
        else {
            return true;
        }
    }


    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

             <Grid container justify="center" alignItems="center" direction="column" minHeight={{minHeight: "50vh"}} pt={{xs: 5, sm: 5}} spacind={5}>
                <Grid item style={{ border: "0.2px solid gray", width: "500px"}} sx={{px: 2, py: 2}}>

                    <form id='loginForm' onSubmit={handleSubmit(props.handleSubmitConfirmPassword)}>
                    <Grid container justify="center" alignItems="center" direction="column">

                        <Box textAlign="center"
                            sx={{width: "100%", height: 70,}}
                        > 
                            <Typography variant="h5">Reseteaza Parola</Typography>
                            <Divider sx={{ borderBottomWidth: 1, borderColor: "black", mt: 1 }} />
                            <Typography variant="subtitle2">Introduceti codul primit prin e-mail si noua parola</Typography>
                        </Box>

                        {!errMsg ?
                            <React.Fragment></React.Fragment>
                                :
                            <Typography
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 1 }}
                            >
                                {errMsg}
                            </Typography>
                        }

                        <Box sx={{padding: 3}}></Box>
                        <TextField variant="standard" size="small" label="Cod" fullWidth margin="dense"
                            {...register("verificationCode",
                                { required: ValidationMessages.REQUITED_MESSAGE }
                            )}
                            error={!!errors?.verificationCode}
                            helperText={errors?.verificationCode ? errors.verificationCode.message : null}
                        />

                        <TextField variant="standard" size="small" label="Parola" fullWidth margin="dense"
                            type={showPassword ? "text" : "password"} 
                            autoComplete='off'
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                    >
                                        {!showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                            }}

                            {...register("newPassword", 
                                {required: ValidationMessages.REQUITED_MESSAGE,
                                pattern: {
                                    value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                    message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT,
                                }  
                                }
                            )} 
                            error={!!errors?.newPassword}
                            helperText={errors?.newPassword ? errors.newPassword.message : null}
                        />

                        <TextField variant="standard" size="small" label="Confirmare Parola" fullWidth margin="dense"
                            type={showPasswordConf ? "text" : "password"} 
                            autoComplete='off'
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPasswordConf}
                                    >
                                        {!showPasswordConf ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                            }}

                            {...register("newPasswordConf", 
                                {required: ValidationMessages.REQUITED_MESSAGE,
                                pattern: {
                                    value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                    message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT
                                },  
                                validate: validatePasswordMatch
                            }
                            )} 
                            error={!!errors?.newPasswordConf}
                            helperText={errors?.newPasswordConf ? errors.newPasswordConf.message : null}
                        />


                        <Button variant="outlined" type='submit' sx={{width: 200, margin: 3}}>Reseteaza Parola</Button>

                    </Grid>
                    </form>
                </Grid>
            </Grid>

            </Box>
            </Container>
    );
}



const ResetPasswordForm = (props) => {
    const { formState: { errors } } = useForm();
    let navigate = useNavigate();

    const bucketContext = useContext(BucketContext);

    var resetStage = null;
    if(bucketContext.bucket.pswdResetStage == null) {
        resetStage = 'request';
    }
    else{
        resetStage = bucketContext.bucket.pswdResetStage;
    }

    const handleSubmitResetPassword = (data) => {

        PswdManager.resetPassword(data.username)
            .then(response => {
                bucketContext.setBucketValue({
                    pswdResetUsername: data.username,
                    pswdResetStage: 'confirm',
                    snackbar: { open: true, severity: "success", message: "Parola a fost resetata cu succes" }
                });
            })
            .catch(error => {
                if(error.code === 'LimitExceededException') {
                    bucketContext.setBucketValue({pswdResetErrMsg: "Numarul limita de incercari a expirat. Va rugam sa astepati 1 ora." });
                    // bucketContext.setBucketValue({snackbar: { open: true, severity: "error", message: "Numarul limita de incercari a expirat. Va rugam sa astepati 1 ora." } });
                }
                else{
                    bucketContext.setBucketValue({pswdResetErrMsg: "Eroare in timpul schimarii parolei - " + error.code });
                    // bucketContext.setBucketValue({snackbar: { open: true, severity: "error", message: "Eroare in timpul schimarii parolei - " + error.code } });
                }
            });
    }


    const handleSubmitConfirmPassword = (data) => {

        PswdManager.confirmPassword(bucketContext.bucket.pswdResetUsername, data.verificationCode, data.newPassword)
            .then(() => {
                bucketContext.setBucketValue({
                            pswdResetUsername: null,
                            pswdResetStage: null, 
                            pswdResetErrMsg: null,
                            snackbar: { open: true, severity: "success", message: "Parola a fost schimbata cu succes" } 
                        });
                navigate("/login");        
            })
            .catch(error => {
                if(error.code === 'CodeMismatchException'){
                    bucketContext.setBucketValue({pswdResetErrMsg: "Codul furnizat este incorect" });
                    // bucketContext.setBucketValue({snackbar: { open: true, severity: "error", message: "Codul furnizat este incorect" } });
                }
                else{
                    bucketContext.setBucketValue({pswdResetErrMsg: "Eroare in timpul schimarii parolei - " + error.code });
                    // bucketContext.setBucketValue({snackbar: { open: true, severity: "error", message: "Eroare in timpul schimarii parolei - " + error.code } });
                }
            });
    }


    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>
            {resetStage === 'request' ?
                <PasswordResetComponent handleSubmitResetPassword={handleSubmitResetPassword}/>
                    :
                <PasswordResetConfirmComponent handleSubmitConfirmPassword={handleSubmitConfirmPassword} />
            }
        </Box>
        </Container>
    );
}

export default ResetPasswordForm;